import { css, jsx } from '@emotion/core';
import React, { memo, useEffect, useState } from 'react';

import request from '@/utils/axios';

import ContactInitials from './ContactInitials';

const style = {
  image: css`
    border-radius: 50%;
    flex: 0 0 84px;
    width: 84px;
    height: 84px;
    object-fit: cover;
    object-position: center;
  `,
};

const ContactCardImage = memo(function ContactCardImage(props) {
  const { id, name, setContactPhoto, initials } = props;
  const [b64, setb64] = useState(null);
  const [loading, setLoading] = useState(true);
  const [avatarIcon, setAvatarIcon] = useState('loading');

  useEffect(() => {
    if (id) {
      (async function mounted() {
        try {
          const response = await request({
            url: 'image/file',
            responseType: 'arraybuffer',
            params: {
              area: 'p',
              id,
            },
            headers: {
              'Content-Type': 'image/jpeg',
            },
          });
          const base64Image = Buffer.from(response.data, 'binary').toString('base64');
          if (base64Image) {
            const image = `data:image/jpeg;base64,${base64Image}`;
            setb64(image);
            if (setContactPhoto) {
              setContactPhoto(id, image);
            }
          } else {
            setAvatarIcon('user');
          }
          setLoading(false);
        } catch (error) {
          setLoading(false);
          console.log(error);
        }
      })();
    }
  }, [id]);

  return loading || !b64 ? (
    <ContactInitials icon={avatarIcon} initials={initials} />
  ) : (
    <img src={b64} alt={`${name} Profile`} css={style.image} />
  );
});

export default ContactCardImage;
